/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AuthClientHeaderInput,
  AuthClientHeaderInput$Outbound,
  AuthClientHeaderInput$outboundSchema,
} from "./authclientheaderinput.js";

/**
 * How the client authenticates upstream.
 */
export const CreateAuthClientRequestBodyClientType = {
  RemoteSession: "remote_session",
  ServiceAccount: "service_account",
  StaticCredential: "static_credential",
  PassThrough: "pass_through",
} as const;
/**
 * How the client authenticates upstream.
 */
export type CreateAuthClientRequestBodyClientType = ClosedEnum<
  typeof CreateAuthClientRequestBodyClientType
>;

export type CreateAuthClientRequestBody = {
  /**
   * How the client authenticates upstream.
   */
  clientType: CreateAuthClientRequestBodyClientType;
  /**
   * The headers the client sends upstream. Required for static_credential and pass_through clients. Token-generating clients produce their own Authorization header, which cannot be configured.
   */
  headers?: Array<AuthClientHeaderInput> | undefined;
  /**
   * MCP servers that should offer the client.
   */
  mcpServerIds?: Array<string> | undefined;
  /**
   * The client's name.
   */
  name: string;
  /**
   * Confine the client to one project. Omit to share it across the organization's projects.
   */
  projectId?: string | undefined;
  /**
   * The OAuth registration behind a remote_session or service_account client.
   */
  remoteSessionClientId?: string | undefined;
};

/** @internal */
export const CreateAuthClientRequestBodyClientType$outboundSchema:
  z.ZodMiniEnum<typeof CreateAuthClientRequestBodyClientType> = z.enum(
    CreateAuthClientRequestBodyClientType,
  );

/** @internal */
export type CreateAuthClientRequestBody$Outbound = {
  client_type: string;
  headers?: Array<AuthClientHeaderInput$Outbound> | undefined;
  mcp_server_ids?: Array<string> | undefined;
  name: string;
  project_id?: string | undefined;
  remote_session_client_id?: string | undefined;
};

/** @internal */
export const CreateAuthClientRequestBody$outboundSchema: z.ZodMiniType<
  CreateAuthClientRequestBody$Outbound,
  CreateAuthClientRequestBody
> = z.pipe(
  z.object({
    clientType: CreateAuthClientRequestBodyClientType$outboundSchema,
    headers: z.optional(z.array(AuthClientHeaderInput$outboundSchema)),
    mcpServerIds: z.optional(z.array(z.string())),
    name: z.string(),
    projectId: z.optional(z.string()),
    remoteSessionClientId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      clientType: "client_type",
      mcpServerIds: "mcp_server_ids",
      projectId: "project_id",
      remoteSessionClientId: "remote_session_client_id",
    });
  }),
);

export function createAuthClientRequestBodyToJSON(
  createAuthClientRequestBody: CreateAuthClientRequestBody,
): string {
  return JSON.stringify(
    CreateAuthClientRequestBody$outboundSchema.parse(
      createAuthClientRequestBody,
    ),
  );
}
